const zustaende = [
  { kurz: '10', titel: 'Erfasst mit "Fertigungsaufträge bearbeiten" (531) oder erzeugt aus z.B. Materialbedarfsplanung' },
  { kurz: '15', titel: 'Simuliert mit "Terminierung, auch Simulation" (552) (interner Status)' },
  { kurz: '20', titel: 'Terminiert mit "Fertigungsaufträge bearbeiten" (531), mit "Terminierung, auch Simulation" (552) oder mit "Bestellungen und Fertigungsaufträge erzeugen" (374/379)' },
  { kurz: '25', titel: 'In Schnittstelle FA-Bestand über "Ausgabe FA-Bestand an Schnittstelle" (555) (intern)' },
  { kurz: '28', titel: 'In Warteschlange für Freigabe durch "Freigabevorschlag für Arbeitsgänge" (562) (interner Status für Auftragspositionen)' },
  { kurz: '30', titel: 'Freigegeben mit "Auftragsfreigabe (Veranlassung), Fehlteileliste" (561), "Freigabevorschlag für Arbeitsgänge" (562), "Arbeitsgänge getrennt freigeben" (563), "Ausgabe FA-Bestand an Schnittstelle" (555) / "Rücknahme FA-Bestand von Schnittstelle" (556), "Fertigungsaufträge bearbeiten" (531) oder "Bestellungen und Fertigungsaufträge erzeugen" (374/379)' },
  { kurz: '40', titel: 'Papiere gedruckt mit "Werkstattpapiere mit Übergabe an Werkstattbestand" (565)' },
  { kurz: '50', titel: 'In Arbeit bzw. teilentnommen nach erster Rückmeldung über die Programme "Rückmelden Material" (571) - "Rückmeldungen aus Stapeldatei (BDE)" (575)' },
  { kurz: '60', titel: 'Erledigt nach Fertigmeldung' },
];

export default zustaende;

export function getZustandTitle(kurz) {
  return zustaende.find((e) => e.kurz === kurz)?.kurz || '';
}

export function getZustand(kurz) {
  return zustaende.find((e) => e.kurz === kurz) || null;
}
